// Filename: ButtonStyles.ts
//
// Component: Button Styles
//
// Purpose:
// Provide reusable MUI `sx` style objects for the Button component.
// This file centralizes style logic so the Button component stays clean,
// and all styling changes can be made in one place.
//
// What this file does:
// - Uses MUI's `useTheme()` hook to read the active theme values (palette colors, etc.)
// - Returns an object containing style definitions for each supported variant.
// - Each style is typed using `SxProps<Theme>` so TypeScript validates style keys/values.

import { makeStyles } from "tss-react/mui";

export const useButtonStyles = makeStyles()((theme) => ({
  contained: {
          // Use the primary theme color as the background
      backgroundColor: theme.palette.primary.main,

      // Ensure readable text by using the theme’s contrastText color
      color: theme.palette.primary.contrastText,

      // Remove default shadow so the component looks flat / custom
      boxShadow: "none",

      // Custom border radius (square corners)
      borderRadius: "0px",

      // Hover state styling using CSS-in-JS selector
      "&:hover": {
        // Darken background on hover (from the theme)
        backgroundColor: theme.palette.primary.dark,

        // Keep shadow removed on hover too
        boxShadow: "none",
      },
      width: "fit-content"
  },
  text: {
      // Use default text color from the theme
      color: theme.palette.text.primary,

      // Set font size for consistency
      fontSize: "16px",

      // Match contained style: square corners
      borderRadius: "0px",

      // Hover behavior: use theme’s standard hover background
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
  }
}));